export default __webpack_public_path__ + "images/KY.3cf8b70.png";